var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "myGradient",
    gradientTransform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#71CC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4FE5B7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9,14.512c12.416-.5,24.313,7.1,34.776,18.472,12.26,13.321,12.653,13.512,24.42.167,14.592-16.547,32-22.681,52.051-16.113,35.14,11.512,45.222,56.267,19.405,86.047-16.458,18.984-33.89,36.977-50.893,55.407-6.339,6.871-12.453,14.015-19.11,20.505-8.973,8.751-17.534,9.178-25.991.193C62.83,152.911,38.091,126.605,14.28,99.361.359,83.433-1.517,63.816,7.326,44.166,15.808,25.319,29.962,14.58,52.9,14.512Z",
    fill: "url('#myGradient')"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d7bdb5ad67f93d95ab7a95d5b70a6b70.svg";
export { ForwardRef as ReactComponent };